import { axios } from '@/utils/request'

const api = {

    purchaseEdit: '/badminapi/jxc/purchaseEdit',
    purchaseGoodsEdit: '/badminapi/jxc/purchaseGoodsEdit',
    purchaseAdd: '/badminapi/jxc/purchaseAdd',
    purchaseGoodsAdd: '/badminapi/jxc/purchaseGoodsAdd',
    goodsOptions: '/badminapi/jxc/goodsOptions',
    goodsSkuDetail: '/badminapi/jxc/goodsSkuDetail',
    goodsListEdit: '/badminapi/jxc/goodsListEdit',
    purchaseDetail: '/badminapi/jxc/purchaseDetail',
    purchaseList: '/badminapi/jxc/purchaseList',
    purchaseGoodsList: '/badminapi/jxc/purchaseGoodsList',
    getOrderDownloadUrl: '/badminapi/jxc/getPurchaseOrderDownloadUrl',
    purchaseRankEdit: '/badminapi/jxc/tuanRankEdit',
    purchaseDelete: '/badminapi/jxc/tuanDelete',
    setPurchaseAllStatus: '/badminapi/jxc/setTuanAllStatus',
    purchaseOrderList: '/badminapi/jxc/orderList',

    purchaseGoodsDelete: '/badminapi/jxc/purchaseGoodsDelete',
    getBaseOption: '/badminapi/jxc/baseOption',
    getSupplyOption: '/badminapi/jxc/supplyOption',
    purchaseGoodsDetail: '/badminapi/jxc/purchaseGoodsDetail',

    inventoryCheckEdit: '/badminapi/jxc/inventoryCheckEdit',
    inventoryCheckAdd: '/badminapi/jxc/inventoryCheckAdd',
    getInventoryCheckList: '/badminapi/jxc/inventoryCheckListInout',
    inventoryCheckDetail: '/badminapi/jxc/inventoryCheckDetail',
    getCheckTypeOption: '/badminapi/jxc/getCheckTypeOption',
    checkGoodsEdit: '/badminapi/jxc/checkGoodsEdit',
    checkGoodsAdd: '/badminapi/jxc/checkGoodsAdd',
    checkAllGoodsAdd: '/badminapi/jxc/checkAllGoodsAdd',
    checkGoodsList: '/badminapi/jxc/checkGoodsList',
    checkGoodsDetail: '/badminapi/jxc/checkGoodsDetail',
    checkGoodsDelete: '/badminapi/jxc/checkGoodsDelete',
    checkGoodsExamine: '/badminapi/jxc/checkGoodsExamine',
    checkGoodsItemExamine: '/badminapi/jxc/checkGoodsItemExamine',
    checkAllGoodsExamine: '/badminapi/jxc/checkAllGoodsExamine',
    editSale: '/badminapi/jxc/salesEdit',
    addSale: '/badminapi/jxc/salesAdd',
    saleDetail: '/badminapi/jxc/saleDetail',
    getSaleList: '/badminapi/jxc/getSaleList',

    saleGoodsEdit: '/badminapi/jxc/saleGoodsEdit',
    newSaleGoodsEdit: '/badminapi/jxc/newSaleGoodsEdit',
    saleGoodsAdd: '/badminapi/jxc/allSaleGoodsAdd',
    saleGoodsList: '/badminapi/jxc/saleGoodsList',
    saleGoodsDetail: '/badminapi/jxc/saleGoodsDetail',
    saleGoodsDelete: '/badminapi/jxc/saleGoodsDelete',

    getSaleUserList: '/badminapi/jxc/getSaleUserList',
    saleDelete: '/badminapi/jxc/saleDelete',

    userList: '/badminapi/jxc/userlist',

    getWithdrawalList: '/badminapi/order/withdrawalList',
    withdrawalStatusEdit: '/badminapi/order/withdrawalStatusEdit',

    getStockChangeList: '/badminapi/jxc/stockChangeList',
    getStockChangeOutList: '/badminapi/jxc/stockChangeOutList',
    getStockChangeIntoList: '/badminapi/jxc/stockChangeIntoList',
    getStockChangeDetail: '/badminapi/jxc/stockChangeDetail',
    getStockDownloadUrl: '/badminapi/jxc/stockDownloadUrl',
    saleExamine: '/badminapi/jxc/saleExamine',
    purchaseExamine: '/badminapi/jxc/purchaseExamine',
    purchaseAllExamine: '/badminapi/jxc/purchaseAllExamine',

    onCheckGoodsPrint: '/badminapi/jxc/onCheckGoodsPrint',

    getSmartParse: '/api/utils/smartParse',

    saleOrderAdd: '/badminapi/jxc/saleOrderAdd',

    purchaseOrderAdd: '/badminapi/jxc/purchaseOrderAdd',

    getDownloadUrl: '/badminapi/jxc/getDownloadUrl',
    getInvDownloadUrl: '/badminapi/jxc/getInvDownloadUrl',

    getCompanyOptions: '/badminapi/jxc/getCompanyOptions',
    saleCompanyAdd: '/badminapi/jxc/saleCompanyAdd',
    saleCompanyDetail: '/badminapi/jxc/saleCompanyDetail',
    saleCompanyEdit: '/badminapi/jxc/saleCompanyEdit',
    saleCompanyList: '/badminapi/jxc/saleCompanyList',
    saleCompanyDelete: '/badminapi/jxc/saleCompanyDelete',
    orderListEdit: '/badminapi/jxc/orderListEdit',
    setExpressStatus: '/badminapi/jxc/setExpressStatus',
}

export default api

export function saleCompanyAdd(parameter) {
    return axios({
        url: api.saleCompanyAdd,
        method: 'post',
        params: parameter
    })
}

export function saleCompanyEdit(parameter) {
    return axios({
        url: api.saleCompanyEdit,
        method: 'post',
        params: parameter
    })
}
export function saleCompanyList(parameter) {
    return axios({
        url: api.saleCompanyList,
        method: 'post',
        params: parameter
    })
}

export function saleCompanyDetail(parameter) {
    return axios({
        url: api.saleCompanyDetail,
        method: 'post',
        params: parameter
    })
}

export function saleCompanyDelete(parameter) {
    return axios({
        url: api.saleCompanyDelete,
        method: 'post',
        params: parameter
    })
}

export function getCompanyOptions(parameter) {
    return axios({
        url: api.getCompanyOptions,
        method: 'get',
        params: parameter
    })
}

export function getInvDownloadUrl(parameter) {
    return axios({
        url: api.getInvDownloadUrl,
        method: 'get',
        params: parameter
    })
}

export function getDownloadUrl(parameter) {
    return axios({
        url: api.getDownloadUrl,
        method: 'get',
        params: parameter
    })
}
export function purchaseOrderAdd(parameter) {
    return axios({
        url: api.purchaseOrderAdd,
        method: 'post',
        params: parameter
    })
}

export function saleOrderAdd(parameter) {
    return axios({
        url: api.saleOrderAdd,
        method: 'post',
        params: parameter
    })
}
export function getSmartParse(parameter) {
    return axios({
        url: api.getSmartParse,
        method: 'get',
        params: parameter
    })
}

export function onCheckGoodsPrint(parameter) {
    return axios({
        url: api.onCheckGoodsPrint,
        method: 'get',
        params: parameter
    })
}

export function getStockDownloadUrl(parameter) {
    return axios({
        url: api.getStockDownloadUrl,
        method: 'get',
        params: parameter
    })
}

export function getStockChangeDetail(parameter) {
    return axios({
        url: api.getStockChangeDetail,
        method: 'get',
        params: parameter
    })
}

export function getStockChangeList(parameter) {
    return axios({
        url: api.getStockChangeList,
        method: 'get',
        params: parameter
    })
}
export function getStockChangeOutList(parameter) {
    return axios({
        url: api.getStockChangeOutList,
        method: 'get',
        params: parameter
    })
}
export function getStockChangeIntoList(parameter) {
    return axios({
        url: api.getStockChangeIntoList,
        method: 'get',
        params: parameter
    })
}

export function withdrawalStatusEdit(parameter) {
    return axios({
        url: api.withdrawalStatusEdit,
        method: 'post',
        data: parameter
    })
}

export function getBaseOption(parameter) {
    return axios({
        url: api.getBaseOption,
        method: 'get',
        params: parameter
    })
}

export function getSupplyOption(parameter) {
    return axios({
        url: api.getSupplyOption,
        method: 'get',
        params: parameter
    })
}

export function getWithdrawalList(parameter) {
    return axios({
        url: api.getWithdrawalList,
        method: 'get',
        params: parameter
    })
}

export function getUserList(parameter) {
    return axios({
        url: api.userList,
        method: 'get',
        params: parameter
    })
}

export function saleDelete(parameter) {
    return axios({
        url: api.saleDelete,
        method: 'get',
        params: parameter
    })
}

export function getSaleUserList(parameter) {
    return axios({
        url: api.getSaleUserList,
        method: 'get',
        params: parameter
    })
}

export function saleGoodsDetail(parameter) {
    return axios({
        url: api.saleGoodsDetail,
        method: 'get',
        params: parameter
    })
}

export function saleGoodsDelete(parameter) {
    return axios({
        url: api.saleGoodsDelete,
        method: 'get',
        params: parameter
    })
}

export function saleGoodsList(parameter) {
    return axios({
        url: api.saleGoodsList,
        method: 'get',
        params: parameter
    })
}
export function newSaleGoodsEdit(parameter) {
    return axios({
        url: api.newSaleGoodsEdit,
        method: 'post',
        data: parameter
    })
}

export function saleGoodsEdit(parameter) {
    return axios({
        url: api.saleGoodsEdit,
        method: 'post',
        data: parameter
    })
}
export function saleGoodsAdd(parameter) {
    return axios({
        url: api.saleGoodsAdd,
        method: 'post',
        data: parameter
    })
}

export function saleDetail(parameter) {
    return axios({
        url: api.saleDetail,
        method: 'get',
        params: parameter
    })
}

export function getSaleList(parameter) {
    return axios({
        url: api.getSaleList,
        method: 'get',
        params: parameter
    })
}

export function editSale(parameter) {
    return axios({
        url: api.editSale,
        method: 'post',
        data: parameter
    })
}
export function addSale(parameter) {
    return axios({
        url: api.addSale,
        method: 'post',
        data: parameter
    })
}


export function checkGoodsItemExamine(parameter) {
    return axios({
        url: api.checkGoodsItemExamine,
        method: 'post',
        data: parameter
    })
}

export function checkGoodsExamine(parameter) {
    return axios({
        url: api.checkGoodsExamine,
        method: 'post',
        data: parameter
    })
}

export function checkAllGoodsExamine(parameter) {
    return axios({
        url: api.checkAllGoodsExamine,
        method: 'post',
        data: parameter
    })
}

export function checkGoodsDelete(parameter) {
    return axios({
        url: api.checkGoodsDelete,
        method: 'get',
        params: parameter
    })
}

export function checkGoodsDetail(parameter) {
    return axios({
        url: api.checkGoodsDetail,
        method: 'get',
        params: parameter
    })
}

export function checkGoodsList(parameter) {
    return axios({
        url: api.checkGoodsList,
        method: 'get',
        params: parameter
    })
}

export function checkGoodsEdit(parameter) {
    return axios({
        url: api.checkGoodsEdit,
        method: 'post',
        data: parameter
    })
}
export function checkGoodsAdd(parameter) {
    return axios({
        url: api.checkGoodsAdd,
        method: 'post',
        data: parameter
    })
}

export function checkAllGoodsAdd(parameter) {
    return axios({
        url: api.checkAllGoodsAdd,
        method: 'post',
        data: parameter
    })
}

export function getCheckTypeOption(parameter) {
    return axios({
        url: api.getCheckTypeOption,
        method: 'get',
        params: parameter
    })
}

export function inventoryCheckDetail(parameter) {
    return axios({
        url: api.inventoryCheckDetail,
        method: 'get',
        params: parameter
    })
}

export function getInventoryCheckList(parameter) {
    return axios({
        url: api.getInventoryCheckList,
        method: 'get',
        params: parameter
    })
}

export function inventoryCheckEdit(parameter) {
    return axios({
        url: api.inventoryCheckEdit,
        method: 'post',
        data: parameter
    })
}
export function inventoryCheckAdd(parameter) {
    return axios({
        url: api.inventoryCheckAdd,
        method: 'post',
        data: parameter
    })
}

export function purchaseGoodsDetail(parameter) {
    return axios({
        url: api.purchaseGoodsDetail,
        method: 'get',
        params: parameter
    })
}
export function purchaseGoodsDelete(parameter) {
    return axios({
        url: api.purchaseGoodsDelete,
        method: 'get',
        params: parameter
    })
}

export function purchaseEdit(parameter) {
    return axios({
        url: api.purchaseEdit,
        method: 'post',
        data: parameter
    })
}
export function purchaseAdd(parameter) {
    return axios({
        url: api.purchaseAdd,
        method: 'post',
        data: parameter
    })
}

export function purchaseGoodsEdit(parameter) {
    return axios({
        url: api.purchaseGoodsEdit,
        method: 'post',
        data: parameter
    })
}
export function purchaseGoodsAdd(parameter) {
    return axios({
        url: api.purchaseGoodsAdd,
        method: 'post',
        data: parameter
    })
}
export function getOrderDownloadUrl(parameter) {
    return axios({
        url: api.getOrderDownloadUrl,
        method: 'get',
        params: parameter
    })
}

export function purchaseGoodsList(parameter) {
    return axios({
        url: api.purchaseGoodsList,
        method: 'get',
        params: parameter
    })
}

export function purchaseList(parameter) {
    return axios({
        url: api.purchaseList,
        method: 'get',
        params: parameter
    })
}
export function purchaseDetail(parameter) {
    return axios({
        url: api.purchaseDetail,
        method: 'get',
        params: parameter
    })
}
export function getGoodsOptions(parameter) {
    return axios({
        url: api.goodsOptions,
        method: 'get',
        params: parameter
    })
}
export function getGoodsSkuDetail(parameter) {
    return axios({
        url: api.goodsSkuDetail,
        method: 'get',
        params: parameter
    })
}
export function goodsListEdit(parameter) {
    return axios({
        url: api.goodsListEdit,
        method: 'get',
        params: parameter
    })
}


export function deleteTuan(parameter) {
    return axios({
        url: api.tuanDelete,
        method: 'post',
        data: parameter
    })
}

export function setTuanRank(parameter) {
    return axios({
        url: api.tuanRankEdit,
        method: 'post',
        data: parameter
    })
}


export function setTuanAllStatus(parameter) {
    return axios({
        url: api.setTuanAllStatus,
        method: 'post',
        data: parameter
    })
}
export function getTuanUserList(parameter) {
    return axios({
        url: api.tuanOrderList,
        method: 'post',
        data: parameter
    })
}

export function saleExamine(parameter) {
    return axios({
        url: api.saleExamine,
        method: 'post',
        data: parameter
    })
}

export function purchaseExamine(parameter) {
    return axios({
        url: api.purchaseExamine,
        method: 'post',
        data: parameter
    })
}
export function purchaseAllExamine(parameter) {
    return axios({
        url: api.purchaseAllExamine,
        method: 'post',
        data: parameter
    })
}
export function orderListEdit(parameter) {
    return axios({
        url: api.orderListEdit,
        method: 'post',
        data: parameter
    })
}
export function setExpressStatus(parameter) {
    return axios({
        url: api.setExpressStatus,
        method: 'post',
        data: parameter
    })
}